import { FinalScreen } from '@/screens/mini-games'

export default function () {
  return <FinalScreen />
}
